import React, { useEffect, useState } from 'react';
import { Modal } from './Modal';
import { Send, CheckCircle, Building2 } from 'lucide-react';
interface RequestAllocationModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export function RequestAllocationModal({
  isOpen,
  onClose
}: RequestAllocationModalProps) {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success'>('idle');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('submitting');
    // Simulate API call
    setTimeout(() => {
      setStatus('success');
    }, 1500);
  };
  // Reset state when modal closes
  useEffect(() => {
    if (!isOpen) {
      setTimeout(() => setStatus('idle'), 300);
    }
  }, [isOpen]);
  return <Modal isOpen={isOpen} onClose={onClose} className="max-w-md" data-id="element-215">
      <div className="p-8 md:p-10" data-id="element-216">
        <div className="flex items-center gap-2 mb-2 text-gold-400/70 text-[10px] font-mono tracking-[0.3em] uppercase" data-id="element-217">
          <Building2 className="w-3 h-3" data-id="element-218" />
          Institutional Inquiry
        </div>

        <h2 className="text-2xl font-bold text-white tracking-tight mb-2" data-id="element-219">
          Request Allocation
        </h2>
        <p className="text-slate-400 text-sm mb-8" data-id="element-220">
          Delta Street is currently accepting capital from qualified
          institutional buyers and family offices.
        </p>

        {status === 'success' ? <div className="py-12 flex flex-col items-center text-center" data-id="element-221">
            <div className="w-16 h-16 bg-gold-400/10 rounded-full flex items-center justify-center mb-6 border border-gold-400/20" data-id="element-222">
              <CheckCircle className="w-8 h-8 text-gold-400" data-id="element-223" />
            </div>
            <h3 className="text-xl font-bold text-white mb-2" data-id="element-224">
              Request Received
            </h3>
            <p className="text-slate-400 text-sm" data-id="element-225">
              Our investor relations team will review your inquiry and contact
              you shortly with the requested materials.
            </p>
            <button onClick={onClose} className="mt-8 px-8 py-3 border border-slate-700 text-slate-300 text-sm tracking-wide hover:border-gold-400/50 hover:text-gold-300 transition-all duration-300" data-id="element-226">
              Close Window
            </button>
          </div> : <form className="space-y-5" onSubmit={handleSubmit} data-id="element-227">
            <div className="grid grid-cols-2 gap-4" data-id="element-228">
              <div data-id="element-229">
                <label className="block text-xs font-bold tracking-widest text-slate-400 uppercase mb-2" data-id="element-230">
                  First Name
                </label>
                <input type="text" required className="w-full bg-base-950 border border-slate-800 px-4 py-3 text-white focus:outline-none focus:border-gold-400 transition-colors text-sm" data-id="element-231" />
              </div>
              <div data-id="element-232">
                <label className="block text-xs font-bold tracking-widest text-slate-400 uppercase mb-2" data-id="element-233">
                  Last Name
                </label>
                <input type="text" required className="w-full bg-base-950 border border-slate-800 px-4 py-3 text-white focus:outline-none focus:border-gold-400 transition-colors text-sm" data-id="element-234" />
              </div>
            </div>

            <div data-id="element-235">
              <label className="block text-xs font-bold tracking-widest text-slate-400 uppercase mb-2" data-id="element-236">
                Institution / Firm
              </label>
              <input type="text" required className="w-full bg-base-950 border border-slate-800 px-4 py-3 text-white focus:outline-none focus:border-gold-400 transition-colors text-sm" data-id="element-237" />
            </div>

            <div data-id="element-238">
              <label className="block text-xs font-bold tracking-widest text-slate-400 uppercase mb-2" data-id="element-239">
                Work Email
              </label>
              <input type="email" required className="w-full bg-base-950 border border-slate-800 px-4 py-3 text-white focus:outline-none focus:border-gold-400 transition-colors text-sm" data-id="element-240" />
            </div>

            <button type="submit" disabled={status === 'submitting'} className="w-full flex items-center justify-center gap-2 bg-gold-400 text-slate-950 font-bold tracking-widest uppercase py-4 mt-6 hover:bg-gold-300 transition-colors clip-corner disabled:opacity-70 disabled:cursor-not-allowed" data-id="element-241">
              {status === 'submitting' ? 'Submitting...' : <>
                  Submit Inquiry
                  <Send className="w-4 h-4" data-id="element-242" />
                </>}
            </button>
          </form>}
      </div>
    </Modal>;
}